export default __webpack_public_path__ + "static/media/404-img.37f002c9.png";